import styled from 'styled-components';

function Logo() {
  return (
    <Wrap>
      <LogoWrap>
        <a href="tel:02-733-7112" title="Phone">
          <LogoImg src="/images/phone.svg" />
          <span>사무실 직원 전화</span>
        </a>
      </LogoWrap>
      <LogoWrap2>
        <a
          href="https://m.expert.naver.com/expert/profile/home?storeId=100001175"
          target="_blank"
          title="Naver Expert"
        >
          <LogoImg src="/images/headset.svg" />
          <span>변호사 실시간 상담</span>
        </a>
      </LogoWrap2>
      <MobileBtn>
        <MLogoWrap>
          <a href="tel:02-733-7112" title="Phone">
            <MLogoImg src="/images/phone.svg" />
            <span>사무실 직원 전화</span>
          </a>
        </MLogoWrap>
        <MLogoWrap2>
          <a
            href="https://m.expert.naver.com/expert/profile/home?storeId=100001175"
            target="_blank"
            title="Naver Expert"
          >
            <MLogoImg src="/images/headset.svg" />
            <span>변호사 실시간 상담</span>
          </a>
        </MLogoWrap2>
      </MobileBtn>
    </Wrap>
  );
}
const MLogoImg = styled.img`
  width: 20px;
  vertical-align: middle;
  margin-right: 10px;
`;
const MLogoWrap2 = styled.div`
  display: inline-block;
  width: 40%;
  padding: 5%;
`;
const MLogoWrap = styled.div`
  display: inline-block;
  width: 40%;
  padding: 5%;
`;
const MobileBtn = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(241, 191, 120, 0.9);
  a {
    color: #fff;
  }
  display: none;
  @media only screen and (max-width: 750px) {
    display: block;
  }
  text-align: center;
  z-index: 100;
`;
const LogoImg = styled.img`
  width: 30px;
  vertical-align: middle;
`;
const LogoWrap2 = styled.div`
  position: fixed;
  bottom: 7.5em;
  right: 2.5em;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 30px;
  box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.2);
  background-color: #f1bf78;
  transition: 0.3s ease-out;
  overflow: hidden;
  line-height: 60px;
  span {
    display: none;
    color: #fff;
    margin-left: 10px;
    font-weight: bold;
  }
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
  &:hover {
    width: 190px;
    span {
      display: inline-block;
    }
  }
  @media only screen and (max-width: 750px) {
    display: none;
  }
`;
const LogoWrap = styled.div`
  text-align: center;
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 30px;
  box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.2);
  background-color: #f1bf78;
  transition: 0.3s ease-out;
  overflow: hidden;
  line-height: 60px;
  span {
    display: none;
    color: #fff;
    margin-left: 10px;
    font-weight: bold;
  }
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
  &:hover {
    width: 190px;
    span {
      display: inline-block;
    }
  }
  position: fixed;
  bottom: 2.5em;
  right: 2.5em;
  @media only screen and (max-width: 750px) {
    display: none;
  }
`;
const Wrap = styled.div``;
export default Logo;
